import React from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import style from './conclusionHeader.scss';
import { calcPrice } from '../../services/helper';

// Components
import CaravanOutsideImage from '../caravan/caravanImage/caravanOutsideImageComponent';
import CaravanInsideImage from '../caravan/caravanImage/caravanInsideImageComponent';
import CaravanModel from '../caravan/caravanModel/caravanModelComponent';
import CaravanWeight from '../caravan/caravanWeight/caravanWeightComponent';
import LoadConfiguration from './loadConfigurationComponent';
import Price from '../util/Price';

function ConclusionHeader(props) {
    const { configuration } = props;

    return (
        <div className={style.container}>
            <div className={style.carModel}>
                <h2>{t`Hier ist ihr`} <br />{t`neuer La Strada`}</h2>
                <CaravanModel />
                <h1 className={style.price}>
                    <Price value={calcPrice(configuration)} />*
                </h1>
                <CaravanWeight />
            </div>
            <div className={style.carImage}>
                <CaravanOutsideImage />
            </div>
            <div className={style.interiorImage}>
                <CaravanInsideImage />
                <LoadConfiguration />
            </div>
        </div>
    );
}

const mapStateToProps = state => ({
    configuration: state.configuration,
});

export default connect(mapStateToProps, null)(ConclusionHeader);
